import { values } from "lodash";
import Type, { Value } from "./Type";

export const Category = {
  Academia: "Academia",
  Government: "Government",
  Industry: "Industry",
  NationalLaboratory: "National Laboratory",
  UtilityCompany: "Utility Company",
  Other: "Other",
};

export class Categories extends Type<Value> {
  values = () => values(Category).map((v) => ({ name: v, label: v }));
};

const categories = new Categories();

export default categories;
